import React from 'react';
import PersonalAllowanceAlert from './PersonalAllowanceAlert';
import PersonalPension from './PersonalPension';
import SummaryTable from './SummaryTable';

const OutputContainer = ({ results, salary, config }) => {
    const { effectivePersonalAllowance, personalPension, pensionDeduction } = results;
  
  return (
    <div>
      <PersonalAllowanceAlert effectivePersonalAllowance={effectivePersonalAllowance} salary={salary} pensionDeduction={pensionDeduction} config={config} />
      <PersonalPension personalPension={personalPension} salary={salary} config={config} />
      <SummaryTable results={results} />
      </div>
  );
};

export default OutputContainer;
